// extracted by mini-css-extract-plugin
export default {"logo":"x2w504","tooltip":"XxGLJI","link":"Tz56Eh"};